import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class PagoConsignanteService {

     constructor(private http: HttpClient) {
    
    }
    
    registrar(pago_consignante) {
      // console.log("entramos en registrar")

      return this.http.post<any>('https://vertigofin.herokuapp.com/pago_consignantes', { pago_consignante })
        .pipe(map(confirmacion => {
       
            // console.log("entramos en respuesta de pago_consignante")
            // console.log(confirmacion)
            return confirmacion;
        }));
    }

}